export const CustomCard = ({ children, className }) => {
  return (
    <div
      className={`bg-background rounded-md !px-5 !py-5 md:!py-0 shadow-[0px_4px_5px_1px_rgba(0,0,0,0.25)] ${className}`}
    >
      {children}
    </div>
  );
};
